import { render, staticRenderFns } from "./com-reg-channels.vue?vue&type=template&id=8a97c96c"
import script from "./com-reg-channels.vue?vue&type=script&lang=js"
export * from "./com-reg-channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a97c96c')) {
      api.createRecord('8a97c96c', component.options)
    } else {
      api.reload('8a97c96c', component.options)
    }
    module.hot.accept("./com-reg-channels.vue?vue&type=template&id=8a97c96c", function () {
      api.rerender('8a97c96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-reg-channels.vue"
export default component.exports